import axiosInstance from "global/helpers/axiosInstance";
import {
  CHECKACTIVO_ERROR,
  CHECKACTIVO_LOADING,
  CHECKACTIVO_RESET,
  CHECKACTIVO_SUCCESS,
} from "../../ActionTypes";

export const wsGetCheckActivo = (usuario, token) => (dispatch) => {
  dispatch({
    type: CHECKACTIVO_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/checkTotpActivo/${usuario}/${token}`)
      .then((res) => {
        sessionStorage.token = res.data.token;
        dispatch({
          type: CHECKACTIVO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: CHECKACTIVO_ERROR,
          payload: error,
        });
      });
  });
};

export const checkActivoReset = () => (dispatch) => {
  dispatch({
    type: CHECKACTIVO_RESET,
  });
};
